module.exports = __webpack_public_path__ + "img/newbg2.06f3197e.jpg";